import React, { useState } from "react";
import { Button } from "@onegovbugs/onegov-react-components";
import styles from "./Qualification.module.scss";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Create from "@material-ui/icons/Create";

export const QualificationList = ({
  props,
  qualificationList,
  deleteActionHandler,
}) => {
  return (
    <>
      {qualificationList.map((el, i) => (
        <div key={"qual-" + i} className={`${styles.editSection}`}>
          <>
            <div className={"row"}>
              <div className={"col-3"}>
                <label>Issuing authority</label>
              </div>
              <div className={"col-7 " + styles.divContent}>
                {el.issuingAuthority}
              </div>

              <div className={"col-2 " + styles.editButtonSection}>
                <Create
                  onClick={() => {
                    props.history.push(`./qualification/detail/${i}`);
                  }}
                />
                <DeleteOutline
                  onClick={() => {
                    deleteActionHandler(i);
                  }}
                />
              </div>
            </div>
            {el.courseName && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Course Name</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.courseName}
                </div>
              </div>
            )}
             {el.institutionName && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Institution Name</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.institutionName}
                </div>
              </div>
            )}
             {el.certificateName && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Certificate Name</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.certificateName}
                </div>
              </div>
            )}
            <div className={"row"}>
              <div className={"col-3"}>
                <label>Certificate Date</label>
              </div>
              <div className={"col-7 " + styles.divContent}>
                {el.dayOfCertificateDate}/{el.monthOfCertificateDate}/
                {el.yearOfCertificateDate}
              </div>
            </div>
            {el.details && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Details</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.details}
                </div>
              </div>
            )}
          </>
        </div>
      ))}
    </>
  );
};

export default QualificationList;
